import styled from "styled-components";
import React from "react";

const RaksLogoStyle = styled.div`
  display: grid;
  align-content: start;
  grid-gap: 8px;
  text-align: right;
`;

export const RaksLogo = ({
  appName,
  appDesc
}: {
  appName?: string;
  appDesc?: string;
}) => (
  <RaksLogoStyle>
    <div className="appName">{appName || "raks"}</div>
    <h6 className="medium">{appDesc || ''}</h6>
  </RaksLogoStyle>
);

export default RaksLogo;
